/**
 * @param {OrderData} order
 * @param {Array.<DataLayerProduct>} products
 * @returns {Object}
 */
export function checkoutFinishData(order, products) {
  return {
    "ecommerce": {
      "purchase": {
        "actionField": order,
        "products": products
      }
    },
    'event': 'gtm-ee-event',
    'gtm-ee-event-category': 'Enhanced Ecommerce',
    'gtm-ee-event-action': 'Purchase Page',
    'gtm-ee-event-non-interaction': 'False',
  };
}